(function($) {

    var device = $(window).width()

    $(document).ready(function() {
        setTimeout(() => {
            $(window).scrollTop(0);
        })
        $(window).scroll(function() {
            var scroll = $(window).scrollTop();
            if( device > 767){
                lineScroll(scroll)
                line2Scroll(scroll);
            }
        });
    });

    function lineScroll(scroll){
        $el = $('.line-animation');
        $el.each(function( index ) {
            var divoffset = $(this).offset().top - 200;
            var divheight = $(this).height();
            $el2 = $(this).find('.line');
            var diff = scroll - divoffset;
            if( scroll >= divoffset)
            {   
                $el2.css({
                    height: diff + 50,
                    maxHeight: divheight
                }); 
            }else{
                $el2.css({
                    height: 0
                }); 
            }
        });
        
        
    }

    function line2Scroll(scroll){
        $line2 = $('.line2-animation');

        $line2.each(function( index ) {
            var divoffset = $(this).offset().top - 200;
            var divheight = $(this).height();
            $el2 = $(this).find('.line2');
            var diff = scroll - divoffset;
            if( scroll >= divoffset)
            {   
                $el2.css({
                    height: diff + 50,
                    maxHeight: divheight
                }); 
            }else{
                $el2.css({
                    height: 0
                }); 
            }
        });
    }

    butter.init({
        wrapperId: 'butter',
        cancelOnTouch: true
    });
    
})(jQuery);